import { Component, type ReactNode, type ErrorInfo } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      return (
        <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 p-8">
          <div className="rounded-xl border border-red-200 bg-red-50 p-6 max-w-lg w-full text-center shadow">
            <p className="text-4xl mb-3">⚠️</p>
            <h2 className="text-lg font-bold text-red-800 mb-2">Error al cargar esta página</h2>
            <p className="text-sm text-red-600 font-mono break-all">
              {this.state.error?.message ?? 'Error desconocido'}
            </p>
            <button
              className="mt-5 rounded-lg bg-navy px-5 py-2 text-sm font-semibold text-white hover:bg-blue-900 transition-colors"
              onClick={() => { this.setState({ hasError: false, error: undefined }); window.location.reload() }}
            >
              Recargar página
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
